import React, {useContext, useEffect, useState} from 'react';
import {useFormikContext} from "formik";

import LockFieldButton from "../../LockFieldButton";

import {ProductShowContext} from "../../../context/ProductShowContext";

// LockProductButton and LockVariationButton have the same functions but not the same rendering
// we should create a single component later
function LockVariationButton() {
    const [notAvailableKeys] = useState([
        '@id', // do not remove this
        '@type', // do not remove this
        'variation', // do not remove this
        'lockedOptions', // array of option ids set by master feeds, not a boolean lock
        'options', // handled separately (one lock per variation option)
        'url',
        'upc',
        'barcode',
        'discountedPriceStartDate',
        'discountedPriceEndDate',
        'status'
    ]);

    const [availableKeys] = useState([
        'externalId',
        'name',
        'sku',
        'price',
        'outletPrice',
        'discountedPrice',
        'ecoTax',
        'stock',
        'weight',
        'pictures'
    ]);

    const [isEveryFieldLocked, setIsEveryFieldLocked] = useState(false);

    const {values, setFieldValue} = useFormikContext();
    const {retailerOptionsValueList} = useContext(ProductShowContext);

    // option ids displayed for this variation (one lock per option)
    const optionIds = Object.keys(retailerOptionsValueList || {});

    // when a lock field value change
    useEffect(() => {
        if (!values.variationLock) {
            setIsEveryFieldLocked(false);
            return;
        }

        // make a copy to not directly delete form values
        const variationLockValues = structuredClone(values.variationLock);

        // remove key that not exist in the form
        notAvailableKeys.forEach(key => {
            delete variationLockValues[key];
        });

        const valueHasEveryAvailableKeys = availableKeys.every(key => variationLockValues.hasOwnProperty(key));

        const optionLocks = values.variationLock.options || {};
        const isEveryOptionLocked = optionIds.every(optionId => optionLocks[optionId] === true);

        if (valueHasEveryAvailableKeys) {
            const isEveryFlatFieldLocked = Object.values(variationLockValues).every((lock) => lock === true);

            setIsEveryFieldLocked(isEveryFlatFieldLocked && isEveryOptionLocked);
        }
    }, [values.variationLock, retailerOptionsValueList])

    function updateAllLockFields(isLock) {
        let allLockedFields = {};

        if (values.variationLock) {
            const variationLockValues = structuredClone(values.variationLock);

            // remove notAvailableKeys from values to change
            const filtered = Object.entries(variationLockValues).filter(([key]) => !notAvailableKeys.includes(key))

            filtered.forEach(([key]) => {
                variationLockValues[key] = isLock
            });

            allLockedFields = variationLockValues;
        } else {
            availableKeys.forEach((key) => {
                allLockedFields[key] = isLock
            })
        }

        // one lock per displayed option
        const options = {};
        optionIds.forEach((optionId) => {
            options[optionId] = isLock;
        });
        allLockedFields.options = options;

        values.stockInventories.forEach((stockInventory, index) => {
            stockInventory.locked = isLock;
        })

        setFieldValue('variationLock', allLockedFields)
    }

    return (
        <LockFieldButton
            isLocked={isEveryFieldLocked}
            onClick={() => updateAllLockFields(!isEveryFieldLocked)}
        />
    );
}

export default LockVariationButton;
